import { BaanRueJaiClient } from "./clients/BaanRueJaiClient";
import { HTTPClient } from "./clients/HTTPClient";
import { ArticleUseCase } from "./features/articles/ArticleUseCase";
import { BackendAdminClient } from "./clients/BackendAdminClient";

const baseURL = process.env.HOST;
const httpClient = new HTTPClient(baseURL);
export const baanRueJaiClient = new BaanRueJaiClient(httpClient);
baanRueJaiClient.setAuthorizationToken(localStorage.getItem("accessToken"));

export const articleUseCase = new ArticleUseCase(baanRueJaiClient);

// Setup backend admin client
export const backendAdminClient = new BackendAdminClient()



// WEBPACK FOOTER //
// ./src/dependencies.js